import { emailLogsFragments } from "@/queries/Invoice";
import {
  orderPartyFragments,
  orderDeliveryFragments,
  orderFragments,
  orderUnitSettingsDispaySettingFragments,
} from "@/queries/Order";
import gql from "graphql-tag";

export const invoiceFragments = gql`
  fragment invoiceFragments on Invoice {
    id
    number
    kid
    issueDate
    dueDate
    paymentTerm
    note
    reference
    isDeliveredToFb
    emailLogs {
      ...emailLogsFragments
    }
    supplierParty {
      ...orderPartyFragments
    }
    customerParty {
      ...orderPartyFragments
    }
    orderDelivery {
      ...orderDeliveryFragments
    }
    taxAmount
    lineExtensionAmount
    taxExclusiveAmount
    taxInclusiveAmount
    payableRoundingAmount
    payableAmount
    bban
    iban
    orders {
      ...orderFragments
    }
    unit {
      id
      isCompany
      ...orderUnitSettingsDispaySettingFragments
    }
    customer {
      id
      creditDays
      email
      efakturaEligible
      efakturaIdentifier
      unit {
        id
        canReceiveEhf3
      }
    }
    latestEfakturaSubmission {
      id
      humanStatus
      sendingStatus
      pending
      shipmentId
      errorMessage
      sentAt
    }
    invoicePaymentMethods {
      id
      name
      amount
    }
    invoiceOverdueNotices {
      id
      issueDate
      dueDate
      additionalCharge
      orderNumber
    }
    legalNotes
    customNote
    interestNote
    attachments {
      id
      fileName
      url
    }
  },
  ${orderPartyFragments}
  ${orderDeliveryFragments}
  ${orderFragments}
  ${emailLogsFragments}
  ${orderUnitSettingsDispaySettingFragments}
`;
